import { createStore } from "zustand";

export type TFeatureFlagStore = {
  flags: Set<string>;
  // version: string | null;
};

const createFeatureStore = () => {
  const store = createStore<TFeatureFlagStore>(() => ({
    flags: new Set<string>(),
    // version: window.localStorage.getItem("feature_version"),
  }));

  return store;
};

const FeatureFlagStoreContext = createFeatureStore();

export default FeatureFlagStoreContext;
